import React from 'react';
import styled, { css } from 'styled-components';
import Button from 'gatsby-theme-core/src/components/button/index';
import Content from '../../content';
import { useContentTheme } from '../../content-theme';

const Icon = styled.span`
  flex-shrink: 0;
  height: 44px;
  width: 44px;

  @supports not (mask: url()) {
    background-image: url(${({ $icon }) => $icon});
    background-size: cover;
  }

  @supports (mask: url()) {
    background-color: black;
    ${({ $contentTheme }) => $contentTheme === 'light' && css`
      background-color: white;
    `}
    ${({ $contentTheme }) => $contentTheme === 'standout' && css`
      background-color: white;
    `}
    mask: url(${({ $icon }) => $icon}) no-repeat center;
    mask-size: contain;
  }
`;

const Title = styled.h2`
  margin-top: 0;
  margin-bottom: 0;

`;

const Item = styled.li`
  display: flex;
  > * {
    flex-grow: 1;
    display: flex;
    align-items: center;
    text-align: left;
    gap: 0.75rem;
    ${({ $contentTheme }) => $contentTheme === 'light' && css`
      color: white;
    `}
  }

  a {
    color: inherit;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }

  ${Content} {
    flex-grow: 1;
  }
`;

const ListItem = ({
  className,
  title,
  content,
  icon,
  link,
  withLink = false,
  chevronRight = false,
  overrideContentTheme = null,
}) => {
  const { contentTheme: contextContentTheme } = useContentTheme();
  const contentTheme = overrideContentTheme ?? contextContentTheme; // used in pdv

  return (
    <Item className={className} $contentTheme={contentTheme}>
      <Button
        wrapper
        possibleSpan
        chevronRight={chevronRight}
        to={withLink ? null : link}
      >
        {icon?.ext === '.svg' && (
          <Icon
            className="list-item-icon" // we need this in pdv styles
            $contentTheme={contentTheme}
            $icon={icon.url}
          />
        )}
        {title && (
          <Title>{title}</Title>
        )}
        <Content
          asSpan
          content={content}
        />
        {withLink && link && (
          <Button
            chevronRight={chevronRight}
            to={link}
            link
          >
            <span>Lees meer</span>
          </Button>
        )}
      </Button>
    </Item>
  );
};

export default styled(ListItem)``;
